// https://fr.wikipedia.org/wiki/Localisation_linguistique
module.exports = {
  ALBANIAN: 'sq',
  BOSNIAN: 'bs',
  BULGARIAN: 'bg',
  SIMPLIFIED_CHINESE: 'zh', // = zh-CN
  TRADITIONAL_CHINESE: 'zh-TW',
  CROATIAN: 'hr',
  CZECH: 'cs',
  DANISH: 'da',
  DUTCH: 'nl',
  ENGLISH: 'en',
  FINNISH: 'fi',
  FRENCH: 'fr',
  GERMAN: 'de',
  GREEK: 'el',
  HUNGARIAN: 'hu',
  ITALIAN: 'it',
  KOREAN: 'ko',
  LATVIAN: 'lv',
  LITHUANIAN: 'lt',
  MACEDONIAN: 'mk',
  NORWEGIAN: 'nb',
  POLISH: 'pl',
  PORTUGUESE: 'pt',
  ROMANIAN: 'ro',
  RUSSIAN: 'ru',
  SERBIAN: 'sr',
  SLOVAK: 'sk',
  SLOVENIAN: 'sl',
  SPANISH: 'es',
  SWEDISH: 'sv',
  TURKISH: 'tr',
  UKRAINIAN: 'uk',
  VIETNAMESE: 'vi',
  THAI: 'th',
  CATALAN: 'ca',
};
